import { Component } from '@angular/core';
import { CalendlyUrl } from '../../../../core/enums/calendly-enums';

declare const Calendly: any;

@Component({
  selector: 'app-calendly-green-mobility-dialog',
  standalone: true,
  imports: [],
  templateUrl: './calendly-green-mobility-dialog.component.html',
  styleUrl: './calendly-green-mobility-dialog.component.css'
})
export class CalendlyGreenMobilityDialogComponent {
  modalDialogId: string = 'services_modal_green_mobility'
  calendlyElementId: string = 'calendly-embed-green-mobility';

  constructor() { }

  ngAfterViewInit(): void {
    Calendly.initInlineWidget({
      url: CalendlyUrl.GREEN_MOBILITY,
      parentElement: document.getElementById(this.calendlyElementId),
      text: 'Schedule time with me',
      color: '#80a7a5',
      textColor: '#ffffff',
      branding: true
    });
  }

  openModal() {
    let modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    modal.showModal();
  }

  closeModal(): void {
    let modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    modal.close();
  }
}
